// extracted by mini-css-extract-plugin
export default {"arrow":"ArrowSvgLang_arrow__tuHFY","arrowRtl":"ArrowSvgLang_arrowRtl__KK6yS"};